import { render, staticRenderFns } from "./myActivity.vue?vue&type=template&id=dd219836&scoped=true&"
import script from "./myActivity.vue?vue&type=script&lang=js&"
export * from "./myActivity.vue?vue&type=script&lang=js&"
import style0 from "./myActivity.vue?vue&type=style&index=0&id=dd219836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd219836",
  null
  
)

component.options.__file = "myActivity.vue"
export default component.exports